<template>
    <div class="tile">
        <div class="tile-content">
            <v-error-messages :server-error="serverError" class="stack-m"/>
            <p class="stack-m">You must install the
                <a href="https://support.google.com/accounts/answer/1066447" target="_blank">
                    application Google Authenticator and set it up</a>
                manually or by QR-code to log in Rebilly.</p>
            <div v-if="displaySetup" class="grid-content position-relative">
                <v-inline-loader v-if="isProfileUpdating"/>
                <div class="grid-item grid-item-half grid-item-break-half">
                    <label class="field-label">Secret key</label>
                    <div class="field-group">
                        <r-input :value="profile.totpSecret" disabled/>
                        <r-button type="default" class="no-flex"
                                  @click="generateSecretKey" :disabled="isProfileUpdating">Regenerate
                        </r-button>
                    </div>
                </div>
                <div class="grid-item grid-item-half grid-item-break-half" v-if="profile.totpUrl">
                    <label class="field-label">QR Code</label>
                    <div class="stack-m">
                        <img v-bind:src="profile.totpUrl" alt="qr-code" style="width: 200px; height: 200px;">
                    </div>
                </div>
                <r-button type="default" @click="displayConfirmationModal()">Enable 2FA</r-button>
            </div>
            <r-button type="default" @click="startSetup()" v-if="!displaySetup && !isTwoFactorEnabled" :disabled="isProfileUpdating">Setup 2FA</r-button>
            <r-button type="default" @click="displayConfirmationModal()" v-if="isTwoFactorEnabled" :disabled="isProfileUpdating">Disable 2FA</r-button>
        </div>
        <v-modal :title="twoFAText + ' 2FA'" v-if="isModalVisible" @close="closeModal">
            <div slot="content">
                <p class="stack-m">Verification code consists of 6 digits generated by the Google Authenticator application.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                                class="stack-m"
                                label="Verification Code"
                                v-model="oneTimePassword"/>
                    </div>
                </div>
            </div>
            <template slot="actions">
                <r-button type="primary" :disabled="isProfileUpdating" @click="toggleTwoFactor">{{ twoFAText }} 2FA</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import FormLoaderMixin from '@/mixins/form-loader-mixin';
    import VErrorMessages from '@/components/form/v-error-messages';
    import vInlineLoader from '@/components/v-inline-loader';
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'two-factor-authentication',
        mixins: [
            FormLoaderMixin,
        ],
        components: {
            VErrorMessages,
            vModal,
            vInlineLoader,
        },
        data() {
            return {
                displaySetup: false,
                oneTimePassword: null,
                isModalVisible: false,
            };
        },
        props: {
            profile: {
                type: Object,
                required: true,
            },
            isProfileUpdating: Boolean,
        },
        computed: {
            twoFAText() {
                return (this.isTwoFactorEnabled ? `disable` : `enable`);
            },
            isTwoFactorEnabled() {
                return this.profile.totpRequired;
            },
        },
        methods: {
            startSetup() {
                if (!this.profile.totpSecret) {
                    this.generateSecretKey();
                }
                this.displaySetup = true;
            },
            toggleTwoFactor() {
                this.isModalVisible = false;
                this.$emit('input', {totpRequired: !this.isTwoFactorEnabled, oneTimePassword: this.oneTimePassword});
                this.displaySetup = false;
                this.oneTimePassword = null;
            },
            generateSecretKey() {
                this.$emit('generate-secret-key');
            },
            displayConfirmationModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
        },
    };
</script>
